import React, { Fragment, useContext } from "react";
import HelmetComponent from "../components/HelmetComponent";
import TermsContent from "../components/TermsContent";
import "../styles/termsOfService.css";
import { WebsiteContext } from "../context/AppContext";

const TermsOfService = () => {
  const termsContent = [
    {
      title: "Acceptance of Terms:",
      content:
        "By accessing or using the SSS COVAI TRAVEL'S website, you agree to be bound by these Terms & Conditions, our Privacy Policy, and all applicable laws and regulations.",
    },
    {
      title: "Description of Service:",
      content:
        "The SSS COVAI TRAVEL'S provides a platform that connects passengers with drivers for ride-hailing services via our website or mobile application. We are not a transportation provider, but rather a facilitator between passengers and drivers.",
    },
    {
      title: "User Conduct:",
      content:
        "As a user of the Service, you agree to:"
    },
    {
        title:"",
        content:"Provide accurate, current, and complete information when booking a ride."
    },
    {
        title:"",
        content:"Follow all applicable laws and regulations during the use of the Service."
    },
    {
        title:"",
        content:"Refrain from using the Service for any unlawful, fraudulent, or harmful purposes."
    },
    {
        title:"",
        content:"Respect the driver and other passengers during rides."
    },
    {
      title: "Booking and Payment",
      content:
        "As a user of the Service, you agree to:",
    },
    {
        title:"",
        content:"Payment for rides will be charged through the payment methods provided at the time of booking"
    },
    {
        title:"",
        content:"Prices may vary depending on the route, demand, time, and other factors. You will be notified of the estimated fare prior to confirmation of your ride."
    },
    {
      title: "Acceptance of Terms:",
      content:
        "By accessing or using the SSS COVAI TRAVEL'S Site, you agree to be bound by these Terms & Conditions, our Privacy Policy, and all applicable laws and regulations.",
    }, 
    {
      title: "Privacy:",
      content:
        "Our Privacy Policy governs the collection, use, and disclosure of your personal information. By using the SSS COVAI TRAVEL'S site, you consent to the terms of our Privacy Policy.",
    },
    {
      title: "Modifications to Service:",
      content:
        "The SSS COVAI TRAVEL'S Site reserves the right to modify, suspend, or discontinue all or any part of the service at any time, with or without notice.",
    },  
    {
      title: "Limitation of Liability:",
      content: `In no event shall the SSS COVAI TRAVEL'S Site or its affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, arising out of or in connection with your use of the service.`,
    },
    {
      title: "Governing Law:",
      content: `These Terms & Conditions shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.`,
    },
    {
      title: "Contact Us:",
      content: `If you have any questions or concerns about these Terms & Conditions, please contact us at vlearnenglish2023@gmail.com`,
    },
  ];
  const { color, isMobileView, loading } = useContext(WebsiteContext);
  if (loading){
    return <div className="loader_container"><span class="loader"></span></div>
  }
  return (
    <Fragment>
      <HelmetComponent
        title="Terms of Service | SSS COVAI TRAVEL'S"
        name="description"
        content="Review our terms of service to understand how we use and protect your information."
      />
      <div
        className={isMobileView ? "terms_title_mobile" : "terms_title"}
        style={{ color: color }}
      >
        Terms & Conditions
      </div>
      <div
        className={isMobileView ? "terms_subtitle_mobile" : "terms_subtitle"}
        style={{ color: color }}
      >
        We Are SSS COVAI TRAVEL'S : Welcome to the SSS COVAI TRAVEL'S! Before using our
        services, please read these Terms & Conditions carefully
      </div>
      <div
        className={isMobileView ? "terms_container_mobile" : "terms_container"}
      >
        {termsContent?.map((data, index) => {
          return (
            <div key={index}>
              <TermsContent title={data?.title} content={data?.content} />
            </div>
          );
        })}

        <div className="terms_info" style={{ color: color }}>
          By using the SSS COVAI TRAVEL'S Site, you acknowledge that you have read,
          understood, and agree to be bound by these Terms & Conditions. If you
          do not agree to these terms, please do not use the Site.
        </div>
      </div>
    </Fragment>
  );
};

export default TermsOfService;
